import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import * as ls from "./_csLcl";
import { a } from "./_csAbt";

import * as BtnC from './_cccBtnC';
import * as TblC from "./_ccmTblC";
import * as TextC from "./_ccbTextC";

import * as ica from 'src/ica';
import * as _cv_70 from './_cv_70___Mz';

let $_70rs = [] as ht.ls;

import * as BtnTopC from './_ccmBtnTopC';

export const B = (pz: ht.btnTopCz) => {
  return (
    cr.c(BtnTopC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
      }
    })
  )
};

export const L = (pz: ht.viewListCz) => {

  React.useEffect(() => {
    f.loadAllAsync({
      frcUdt: pz.sPz.udt,
      bfrAsync: () => [
        _cv_70.load_70rLsAsync({
          cdn: pz.cz.cdn,
        })
        .then((_ls: ht.ls) => {
          $_70rs = _ls
        })
      ]
    })
  }, [
    pz.cz.cdn,
  ]);

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewListAbtz[_abtType] ? ica.viewListAbtz[_abtType]() : {};

  const _hdrs = [];
  const _cellCs = [
    {
      boxStlz: a('dw/25 f/n'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: '送信先',
          }
        })
      ]
    },
    {
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: '件名',
          }
        })
      ]
    },
    {
      boxStlz: a('dw/25 f/n'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          ... _abtz.hdrCz.textCz,
          textz: {
            pfx: '送信日時',
          }
        })
      ]
    },
    {
      boxStlz: a('dw/btn f/n'),
      oClds: [
      ]
    },
  ];
  _hdrs.push(
    {
      cellCs: _cellCs
    },
  );

  //hf.l(`_cv_70a 64: ${hf.s($_70rs)}`);
  const _bdys = [] as ht.ls;
  $_70rs?.map( ( _dz: ht.dz ) => {
    const _cellCs = [
      {
        boxStlz: a('dw/25 f/n'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: hf.j(_dz._70ra1100j)?.pfx ?? '',
            }
          })
        ]
      },
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: _dz._pfx,
            }
          })
        ]
      },
      {
        boxStlz: a('dw/25 f/n'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: _dz._70rd1100s,
            }
          })
        ]
      },
      {
        boxStlz: a('dw/10 f/n'),
        oClds: [
          cr.c(BtnC.N, {
            key: -10,
            ... _abtz.bdyCz.btnCz,
            lblCz: {},
            pslPtyz: {
              onPress: () => {
                pz.sPz.set({
                  steps: [1],
                  phs: 'dpy',
                  _70r_fst: _dz._fst,
                })
              }
            },
          })
        ]
      },
    ];
    _bdys.push(
      {
        cellCs: _cellCs
      },
    )
  });

  return (
    cr.c(TblC.N, {
      key: -30,
      ... _abtz.tblCz,
      srlCz: {
        srlStlz: {
          otrz: a('dwx/120'),
        },
      },
      hdrCz: {
        lineCs: _hdrs,
      },
      bdyCz: {
        lineCs: _bdys,
      },
    })
  );
};

